import React, { useState, useEffect } from 'react';
import {
  Card, 
  CardBody, 
  Row,
  Col, 
  label,
} from 'reactstrap';  
import { useTranslation } from 'react-i18next';    
import PageContent from 'layouts/PageContent';
import DailyDowntimeSummaryTrend from './DailyDowntimeSummaryTrend';

const DailyDowntimeSummaryScreen = (props) => { 
  /* ################## useState area start ################## */
  const { t } = useTranslation(['productionDashboard', 'common']);
   
    /* ################## End useState area start ################## */
 
 
  return (
    <>
      <PageContent title={t('productionDashboard:DailyDowntimeSummaryScreen')}>   
        <Row>
          <Col lg={12} md={12} sm={12} xs={12}>  
            <DailyDowntimeSummaryTrend 
              Fecha={null}
              ClaUbicacion={68} // default mid continent
              ClaArea={null}
              ClaCelda={null}
              ClaTurno={null}
              DisableFilters={false}
            >
            </DailyDowntimeSummaryTrend>
          </Col> 
        </Row>  
      </PageContent>
    </>
  );
};

export default DailyDowntimeSummaryScreen;
